import styled from 'styled-components';

type IFlexProps = {
  $direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  $justify?: string;
  $align?: string;
  $gap?: string;
  $wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
};

export const Flex = styled.div<IFlexProps>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction ?? 'row'};
  justify-content: ${({ $justify }) => $justify ?? 'flex-start'};
  align-items: ${({ $align }) => $align ?? 'stretch'};
  flex-wrap: ${({ $wrap }) => $wrap ?? 'nowrap'};
  ${({ $gap }) => ($gap ? `gap: ${$gap};` : '')}
`;
